import ModalDrawer from "../../../../../common/components/organisme/ModalDrawer/ModalDrawer";
import SingleCreateUserLinkInfo from "../SingleCreateUserLinkInfo/SingleCreateUserLinkInfo";
import useQueryURL from "../../../../../common/hooks/useQueryURL";

/**
 * SingleCreateUserLinkModal
 * @param param0 
 * @returns 
 */
export default function SingleCreateUserLinkModal({
  modaleId,
}: {
  modaleId: string;
}) {
  const { getQueryValue, removeQueryValue } = useQueryURL();
  const culkId = getQueryValue(modaleId + "-id");
  const onClose = () => {
    removeQueryValue([modaleId + "-id", modaleId]);

  }
  return (
    <ModalDrawer urlParamName={modaleId} title="Invitation" onClose={onClose}>
      {culkId && <SingleCreateUserLinkInfo culkId={culkId} />}
    </ModalDrawer>
  );
}
